import Vue from 'vue';
import Router from 'vue-router';

// Pages
import Home from '../../pages/index.vue';
import Login from '../../pages/login/index.vue';

const PasswordForgot = () => import(/* webpackChunkName: "password-reset-page" */ '../../pages/password-forgot/index.vue');

Vue.use(Router);

// Pages
const insights = () => import(/* webpackChunkName: "main-metrics" */ '../../pages/insights/index.vue');
const iDepartments = () => import(/* webpackChunkName: "metrics-departments" */ '../../pages/insights/departments/index.vue');
const iCalls = () => import(/* webpackChunkName: "metrics-calls" */ '../../pages/insights/calls/index.vue');
const iAgents = () => import(/* webpackChunkName: "metrics-agents" */ '../../pages/insights/agents/index.vue');
const iHistory = () => import(/* webpackChunkName: "metrics-history" */ '../../pages/insights/history/index.vue');
const iRecordings = () => import(/* webpackChunkName: "metrics-recordings" */ '../../pages/insights/recordings/index.vue');
const iSubmissions = () => import(/* webpackChunkName: "metrics-submissions" */ '../../pages/insights/submissions/index.vue');
const iSurveys = () => import(/* webpackChunkName: metrics-survey */ '../../pages/insights/surveys/index.vue');
const iExports = () => import(/* webpackChunkName: metrics-exports */ '../../pages/insights/exports/index.vue');
const iAbandonReasons = () => import(/* webpackChunkName: metrics-abandon-reasons */ '../../pages/insights/abandon-reasons/index.vue');
const iTags = () => import(/* webpackChunkName: metrics-tags */ '../../pages/insights/tags/index.vue');
const iLooker = () => import(/* webpackChunkName: metrics-looker */ '../../pages/insights/looker/index.vue');
const iReports = () => import(/* webpackChunkName: metrics-reports */ '../../pages/insights/reports/index.vue');
const iAppointments = () => import(/* webpackChunkName: metrics-appointments */ '../../pages/insights/appointments/index.vue');
const iOverview = () => import(/* webpackChunkName: metrics-overview */ '../../pages/insights/overview/index.vue');
const iIndicators = () => import(/* webpackChunkName: metrics-indicators */ '../../pages/insights/indicators/index.vue');
const call = () => import(/* webpackChunkName: "call-info-page" */ '../../pages/insights/history/call/index.vue');

const forms = () => import(/* webpackChunkName: "forms-page" */ '../../pages/forms/index.vue');
const formsModels = () => import(/* webpackChunkName: "forms-models" */ '../../pages/forms/models/index.vue');
const formsBuilder = () => import(/* webpackChunkName: "forms-builder" */ '../../pages/forms/models/builder.vue');
const dataInventory = () => import(/* webpackChunkName: "data-inventory" */ '../../pages/account/data-inventory/index.vue');
const formsRender = () => import(/* webpackChunkName: "forms-render" */ '../../pages/insights/submissions/submission.vue');

const surveys = () => import(/* webpackChunkName: "surveys-page" */ '../../pages/surveys/index.vue');
const surveysModels = () => import(/* webpackChunkName: "surveys-models" */ '../../pages/surveys/models/index.vue');
const surveysBuilder = () => import(/* webpackChunkName: "surveys-builder" */ '../../pages/surveys/models/builder.vue');

const users = () => import(/* webpackChunkName: "users-page" */ '../../pages/users/index.vue');
const branches = () => import(/* webpackChunkName: "branches-page" */ '../../pages/branches/index.vue');
const userProfile = () => import(/* webpackChunkName: "user-profile" */ '../../pages/users/metrics/index.vue');

const departments = () => import(/* webpackChunkName: "departments-page" */ '../../pages/departments/index.vue');
const integration = () => import(/* webpackChunkName: "integration-page" */ '../../pages/integration/index.vue');
const account = () => import(/* webpackChunkName: "account-page" */ '../../pages/account/index.vue');
const cProfile = () => import(/* webpackChunkName: "profile-account-page" */ '../../pages/account/profile/index.vue');
const cBusiness = () => import(/* webpackChunkName: "business-account-page" */ '../../pages/account/business/index.vue');
const cNotifications = () => import(/* webpackChunkName: "notifications-account-page" */ '../../pages/account/notifications/index.vue');
const cAdministrators = () => import(/* webpackChunkName: "administrators-account-page" */ '../../pages/account/administrators/index.vue');
const cSubscriptions = () => import(/* webpackChunkName: "subscriptions-account-page" */ '../../pages/account/subscriptions/index.vue');
const cConfiguration = () => import(/* webpackChunkName: "configuration-account-page" */ '../../pages/account/configurations/index.vue');
const c2FA = () => import(/* webpackChunkName: "2fa-account-page" */ '../../pages/account/2fa/index.vue');
const cIPRestrictions = () => import(/* webpackChunkName: "ip-restrictions-account-page" */ '../../pages/account/ip-restriction/index.vue');
const cRecordings = () => import(/* webpackChunkName: "recordings-account-page" */ '../../pages/account/recordings/index.vue');
const cAbandonReasons = () => import(/* webpackChunkName: "abandon-reasons-account-page" */ '../../pages/account/abandon-reasons/index.vue');
const cFeedback = () => import(/* webpackChunkName: "feedback-page" */ '../../pages/account/feedback/features/index.vue');
const cUtilities = () => import(/* webpackChunkName: "utilities-page" */ '../../pages/account/utilities/index.vue');
const cAPIKey = () => import(/* webpackChunkName: "apiKey-page" */ '../../pages/account/api-keys/index.vue');
const cReferrers = () => import(/* webpackChunkName: "referrers-page" */ '../../pages/account/referrers/index.vue');
const cTopics = () => import(/* webpackChunkName: "topics-page" */ '../../pages/account/topics/index.vue');
const cUploads = () => import(/* webpackChunkName: "uploads-page" */ '../../pages/account/upload-files/index.vue');
const cSSO = () => import(/* webpackChunkName: "sso-page" */ '../../pages/account/sso/index.vue');
const cWorkingHours = () => import(/* webpackChunkName: "working-hours-page" */ '../../pages/account/working-hours/index.vue');
const cAuditLogs = () => import(/* webpackChunkName: "audit-logs-page" */ '../../pages/account/audit-logs/index.vue');
const cForensicAudit = () => import(/* webpackChunkName: "forensic-audit-page" */ '../../pages/account/forensic-audit/index.vue');

const accountActivation = () => import(/* webpackChunkName: "password-reset-page" */ '../../pages/account-activation/index.vue');

const webhooks = () => import(/* webpackChunkName: "webhooks" */ '../../pages/webhooks/index.vue');
const webhooksList = () => import(/* webpackChunkName: "webhooks-list" */ '../../pages/webhooks/list/index.vue');
const webhooksSecrets = () => import(/* webpackChunkName: "webhooks-secrets" */ '../../pages/webhooks/secrets/index.vue');
const webhooksLogs = () => import(/* webpackChunkName: "webhooks-logs" */ '../../pages/webhooks/logs/index.vue');
const webhooksEditor = () => import(/* webpackChunkName: "webhooks-editor" */ '../../pages/webhooks/list/editor.vue');

const calendar = () => import(/* webpackChunkName: "calendar" */ '../../pages/calendar/index.vue');
const calendarAppointments = () => import(/* webpackChunkName: "calendar-appointments" */ '../../pages/calendar/appointments/index.vue');
const calendarAvailabilities = () => import(/* webpackChunkName: "calendar-availabilities" */ '../../pages/calendar/availabilities/index.vue');
const calendarServices = () => import(/* webpackChunkName: "calendar-services" */ '../../pages/calendar/services/index.vue');
const customTemplates = () => import(/* webpackChunkName: "calendar-templates" */ '../../pages/calendar/email-templates/index.vue');
const calendarReports = () => import(/* webpackChunkName: "calendar-reports" */ '../../pages/calendar/metrics/index.vue');
const topicsAI = () => import(/* webpackChunkName: "topics-ai" */ '../../pages/insights/ai/topics/index.vue');

const exportAgentForms = () => import(/* webpackChunkName: "agent-form-export" */ '../../pages/insights/agent-forms/index.vue');

// Tags
const Tags = () => import(/* webpackChunkName: "tags-list" */ '../../pages/tags/index.vue');

// Extensions
const Extensions = () => import(/* webpackChunkName: "extensions-list" */ '../../pages/account/extensions/index.vue');

// Content blocks
const ContentBlocks = () => import(/* webpackChunkName: "content-blocks-list" */ '../../pages/account/content-blocks/index.vue');

// New monitor
const PowerfulMonitor = () => import(/* webpackChunkName: "powerful-monitor" */ '../../pages/live-monitor/index.vue');
const Contacts = () => import(/* webpackChunkName: "powerful-monitor" */ '../../pages/contacts/index.vue');

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      children: [
        {
          path: '/insights',
          name: 'insights',
          component: insights,
          menu: true,
          label: 'menu.insights',
          redirect: '/insights/overview',
          children: [

            {
              path: '/call/:id', name: 'call', component: call, menu: false, label: '',
            },
            {
              path: '/form-submission/:id', name: 'submission', component: formsRender, menu: false, label: '',
            },
            {
              path: '/insights/overview', name: 'insights-overview', label: 'menu.insightsMenu.overview', component: iOverview, menu: true,
            },
            {
              path: '/insights/indicators', name: 'indicators-insights', label: 'menu.insightsMenu.indicators', component: iIndicators, menu: true,
            },
            {
              path: '/insights/calls', name: 'calls-insights', label: 'menu.insightsMenu.calls', component: iCalls, menu: true,
            },
            {
              path: '/insights/segments', name: 'departments-insights', label: 'menu.insightsMenu.departments', component: iDepartments, menu: true,
            },
            {
              path: '/insights/agents', name: 'agents-insights', label: 'menu.insightsMenu.agents', component: iAgents, menu: true,
            },
            {
              path: '/insights/appointments', name: 'appointments-insights', label: 'menu.insightsMenu.appointments', component: iAppointments, menu: true,
            },
            {
              path: '/insights/surveys', name: 'metrics-surveys', label: 'menu.insightsMenu.surveys', component: iSurveys, menu: true,
            },
            {
              path: '/insights/reports', name: 'global-reports', label: 'menu.insightsMenu.reports', component: iReports, menu: true,
            },
            {
              path: '/insights/history', name: 'history', label: 'menu.insightsMenu.history', component: iHistory, menu: true,
            },
            {
              path: '/insights/submissions', name: 'submissions', label: 'menu.insightsMenu.submissions', component: iSubmissions, menu: true,
            },
            {
              path: '/insights/exports', name: 'exports-data', label: 'menu.insightsMenu.exports', component: iExports, menu: true,
            },
            {
              path: '/insights/exports/agent-forms', name: 'exports-agent-form', label: 'menu.insightsMenu.agentForms', component: exportAgentForms, menu: true,
            },
            {
              path: '/insights/abandon-reasons', name: 'metrics-abandon-reasons', label: 'menu.insightsMenu.abandonReasons', component: iAbandonReasons, menu: true,
            },
            {
              path: '/insights/tags', name: 'metrics-tags', label: 'menu.insightsMenu.tags', component: iTags, menu: true,
            },
            {
              path: '/insights/ai/topics', name: 'nps', label: 'menu.insightsMenu.ai.topics', component: topicsAI, menu: true,
            },
            {
              path: '/insights/recordings', name: 'recordings', label: 'menu.insightsMenu.recordings', component: iRecordings, menu: true,
            },
            {
              path: '/insights/custom-reports', name: 'looker', label: 'menu.insightsMenu.looker', component: iLooker, menu: true, feature: 'looker',
            },
          ],
        },
        { name: 'contacts', path: '/contacts', component: Contacts, menu: true, label: 'menu.contacts' },
        {
          path: '/users',
          name: 'users',
          component: users,
          menu: true,
          label: 'menu.users',
        },
        {
          path: '/users/:id', name: 'user-profile', component: userProfile, menu: false, label: 'menu.user-profile',
        },
        {
          path: '/segments', name: 'segments', component: departments, menu: true, label: 'menu.departments',
        },
        {
          path: '/branches', name: 'branches', component: branches, menu: true, label: 'menu.branches',
        },
        {
          path: '/forms',
          name: 'forms',
          component: forms,
          menu: true,
          label: 'menu.forms',
          redirect: '/forms/models',
          children: [
            {
              path: '/forms/models', name: 'forms-models', component: formsModels, menu: true, label: 'menu.forms.models',
            },
            {
              path: '/forms/builder/:id', name: 'forms-builder', component: formsBuilder, menu: true, label: 'menu.forms.builder',
            },
          ],
        },
        {
          path: '/surveys',
          name: 'surveys',
          component: surveys,
          menu: true,
          label: 'menu.surveys',
          redirect: '/surveys/models',
          children: [
            {
              path: '/surveys/models', name: 'surveys-models', component: surveysModels, menu: true, label: 'menu.surveys.models',
            },
            {
              path: '/surveys/builder/:id', name: 'surveys-builder', component: surveysBuilder, menu: true, label: 'menu.surveys.builder',
            },
          ],
        },
        {
          path: '/calendar',
          name: 'calendar',
          component: calendar,
          menu: true,
          feature: 'CALENDAR',
          label: 'menu.calendar.menu',
          redirect: '/calendar/services',
          new: true,
          newAt: '2022/05/15',
          children: [
            {
              path: '/calendar/services', name: 'calendar-services', component: calendarServices, menu: true, label: 'menu.calendar.services',
            },
            {
              path: '/calendar/availabilities', name: 'calendar-availabilities', component: calendarAvailabilities, menu: true, label: 'menu.calendar.availabilities',
            },
            {
              path: '/calendar/email-templates', name: 'calendar-templates', component: customTemplates, menu: true, label: 'menu.calendar.emailTemplates',
            },
            {
              path: '/calendar/reports', name: 'calendar-reports', component: calendarReports, menu: true, label: 'menu.calendar.reports',
            },
            {
              path: '/calendar/appointments', name: 'calendar-appointments', component: calendarAppointments, menu: true, label: 'menu.calendar.appointments',
            },
          ],
        },
        {
          path: '/tags',
          name: 'tags',
          component: Tags,
          menu: true,
          label: 'menu.tags',
          new: true,
          newAt: '2022/04/15',
        },
        {
          path: '/integration', name: 'integration', component: integration, menu: true, label: 'menu.integration',
        },
        {
          path: '/webhooks',
          name: 'webhooks',
          component: webhooks,
          menu: true,
          label: 'menu.webhooks',
          redirect: '/webhooks/list',
          new: true,
          newAt: '2022/04/15',
          children: [
            {
              path: '/webhooks/list', name: 'webhooks-list', component: webhooksList, menu: true, label: 'menu.webhooksMenu.webhooks',
            },
            {
              path: '/webhooks/editor/:id?', name: 'webhooks-editor', component: webhooksEditor, menu: false,
            },
            {
              path: '/webhooks/secrets', name: 'webhooks-secrets', component: webhooksSecrets, menu: true, label: 'menu.webhooksMenu.secrets',
            },
            {
              path: '/webhooks/logs', name: 'webhooks-logs', component: webhooksLogs, menu: true, label: 'menu.webhooksMenu.logs',
            },
          ],
        },
        {
          path: '/account',
          name: 'account',
          component: account,
          menu: false,
          children: [

            {
              path: '/account/profile', name: 'profile-account', component: cProfile, menu: true, label: 'menu.account.profile',
            },
            {
              path: '/account/business', name: 'business-account', component: cBusiness, menu: true, label: 'menu.account.business',
            },
            {
              path: '/account/subscriptions', name: 'subscriptions-account', component: cSubscriptions, menu: false, label: 'menu.account.subscriptions',
            },
            {
              path: '/account/administrators', name: 'administrators-account', component: cAdministrators, menu: true, label: 'menu.account.administrators',
            },
            {
              path: '/account/configuration', name: 'configuration-account', component: cConfiguration, menu: true, label: 'menu.account.configuration',
            },
            {
              path: '/account/2fa', name: '2fa-account', component: c2FA, menu: true, label: 'menu.account.2fa',
            },
            {
              path: '/account/ai/topics', name: 'ai-topics-account', component: cTopics, menu: true, label: 'menu.account.aiTopics',
            },
            {
              path: '/account/ip-restrictions', name: 'ip-restrictions-account', component: cIPRestrictions, menu: true, label: 'menu.account.ip-restrictions',
            },
            {
              path: '/account/recordings', name: 'recordings-settings', component: cRecordings, menu: true, label: 'menu.account.recordings',
            },
            {
              path: '/account/working-hours', name: 'working-hours', component: cWorkingHours, menu: true, label: 'menu.account.workingHours',
            },
            {
              path: '/account/notifications', name: 'notifications-account', component: cNotifications, menu: true, label: 'menu.account.notifications',
            },
            {
              path: '/account/abandon-reasons', name: 'abandon-reason-account', component: cAbandonReasons, menu: true, label: 'menu.account.abandonReasons',
            },
            {
              path: '/account/referrers', name: 'referrers-account', component: cReferrers, menu: true, label: 'menu.account.referrers',
            },
            {
              path: '/account/feedback', name: 'feedback', action: 'feedback', menu: true, label: 'menu.account.feedback',
            },
            {
              path: '/account/utilities', name: 'utilities', component: cUtilities, menu: true, label: 'menu.account.utilities',
            },
            {
              path: '/account/api-keys', name: 'apikey-account', component: cAPIKey, menu: true, label: 'menu.account.apikeys',
            },
            {
              path: '/account/uploads', name: 'uploads-account', component: cUploads, menu: true, label: 'menu.account.uploadFiles', feature: 'store_files'
            },
            {
              path: '/account/sso', name: 'sso-account', component: cSSO, menu: true, label: 'menu.account.sso', feature: 'sso'
            },
            {
              path: '/account/audit-logs', name: 'audit-logs', component: cAuditLogs, menu: true, label: 'menu.account.audit-logs',
            },
            {
              path: '/account/forensic-audit',
              name: 'forensic-audit',
              component: cForensicAudit,
              menu: true,
              label: 'menu.account.forensic-audit',
              new: true,
              newAt: '2026/12/31',
            },
            {
              path: '/account/forensic-audit/:id', name: 'forensic-audit-queue', component: cForensicAudit, menu: false, label: '',
            },
            {
              path: '/account/data-inventory',
              name: 'data-inventory',
              component: dataInventory,
              menu: true,
              label: 'menu.account.dataInventory',
              new: true,
              newAt: '2026/07/30',
            },
            {
              path: '/account/extensions',
              name: 'extensions',
              component: Extensions,
              menu: true,
              label: 'menu.account.extensions',
              new: true,
              newAt: '2026/04/30',
            },
            {
              path: '/account/content-blocks',
              name: 'content-blocks',
              component: ContentBlocks,
              menu: true,
              label: 'menu.account.contentBlocks',
              new: true,
              newAt: '2026/07/07',
            },
          ],
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    { path: '/login/claim/:id', name: 'claim', component: Login, props: true },
    {
      path: '/accounts/activation',
      name: 'accountActivation',
      component: accountActivation,
    },
    {
      path: '/password/forgot',
      name: 'password-forgot',
      component: PasswordForgot,
    },
  ],
});
